import { render } from "./AssignedSubmissionsTab.vue?vue&type=template&id=1a4a56d0&scoped=true"
import script from "./AssignedSubmissionsTab.vue?vue&type=script&lang=ts"
export * from "./AssignedSubmissionsTab.vue?vue&type=script&lang=ts"

import "./AssignedSubmissionsTab.vue?vue&type=style&index=0&id=1a4a56d0&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a4a56d0"
/* custom blocks */
import block0 from "./AssignedSubmissionsTab.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script